import { analytics } from '../base/vietmeet-lib';
import { SET_INITIAL_PERMANENT_PROPERTIES } from './actionTypes';
/**
 * Updates a permanentProperty.
 *
 * @param {Object} properties - An object with properties to be updated.
 * @returns {Function}
 */
export function setPermanentProperty(properties) {
    return (dispatch, getState) => {
        const { isInitialized = false } = getState()['features/analytics'];
        if (isInitialized) {
            analytics.addPermanentProperties(properties);
        }
        else {
            dispatch({
                type: SET_INITIAL_PERMANENT_PROPERTIES,
                properties
            });
        }
    };
}
